/*global chrome*/
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  getSkillsFromStore,
  addSkillToUser,
  filterSearchItem,
  getUserSkills,
  deleteMySkill,
  changeSkillAreaView,
  getDraftSkills,
  getUserHelperSkills,
  getMetaDataSkills,
  clearDraft,
  retrieveMyMetaSkill,
  retrieveMetaByEmail,
  retrieveFilteredMetaSkill,
  retrieveAllTemplates,
  retrieveAllMetaTemplates,
  changeActiveTab,
  setUserEmail,
  setSelectedFilter,
  setSelectedTemplate,
  setSearchQuery,
  deleteV2Agent,
} from "../../../../../redux/actions/skill";
import { changeMode } from "../../../../../redux/actions/appActions";
import { withRouter } from "react-router";
import { compose } from "redux";
import EmptyLoader from "../../../../../components/emptyLoader";
import Loader from "../../../../../components/loader";
import { notify } from "../../../../../redux/actions/snack";
import getColors from "../../../../../components/colors";
import { ReactNotifications, Store } from "react-notifications-component";
import MyDocumentFlow from "../MyDocumentFlow";
import MyHelperItem from "../MyHelperItem";
import { Pagination, Select, Button } from "antd";
import { CloseOutlined } from "@ant-design/icons";
class MyPublishedSkills extends Component {
  constructor(props) {
    super(props);
    this.emailInputRef = React.createRef();
    this.state = {
      skills: [],
      uniqueSkills: [],
      isLoading: true,
      regularSkill: [],
      helperPublished: [],
      userSkillData: [],
      metaSkillData: [],
      isLoadingRegular: true,
      isLoadingHelper: true,
      allPublishedSkill: [],
      searchItem: "",
      publishedPageInfo: [],
      publishedPage: 1,
      userPage: 1,
      otherUserPage: 1,
      hasMore: true,
      isScrolling: true,
      itemsPerPage: 9,
      totalMetaSkills: 0,
      createdBy: "",
      userEmail: "",
      checked: "all",
      isTemplateLodaing: true,
      selectedTemplate: "",
      inAppPage: 1,
      blankPage: 1,
      userDocPage: 1,
      userOnPage: 1,
      webAutoPage: 1,
      importPage: 1,
      skillSetPage: 1,
      desktopPage: 1,
      displayContent: "",
    };
  }
  componentDidUpdate(prevProps, prevState) {
    const {
      publishedPage,
      userPage,
      otherUserPage,
      inAppPage,
      blankPage,
      userDocPage,
      userOnPage,
      webAutoPage,
      importPage,
      desktopPage,
      skillSetPage,
    } = this.state;
    if (prevState.publishedPage !== publishedPage) {
      this.getPublishedSkill();
    } else if (userPage !== prevState.userPage) {
      this.handleUserSubmit();
    } else if (otherUserPage !== prevState.otherUserPage) {
      this.getSkillsByUserEmail();
    } else if (
      inAppPage !== prevState.inAppPage ||
      blankPage !== prevState.blankPage ||
      userDocPage !== prevState.userDocPage ||
      userOnPage !== prevState.userOnPage ||
      webAutoPage !== prevState.webAutoPage ||
      importPage !== prevState.importPage ||
      skillSetPage !== prevState.skillSetPage ||
      desktopPage !== prevState.desktopPage
    ) {
      this.getSkillsByTemplate();
    }
  }

  // componentDidMount() {
  //   if (this.state.checked === "CreatedBy Me"
  //   ) {
  //     this.handleUserSubmit();
  //   } else if (this.state.checked === "CreatedBy") {
  //     this.getSkillsByUserEmail()
  //   }
  //   else {
  //     this.getPublishedSkill()
  //   }
  // }

  componentDidMount() {
    const filter = this.props?.skillReducer?.selectedFilter;
    const template = this.props?.skillReducer?.selectedTemplate;
    if (filter === "CreatedBy Me") {
      this.handleUserSubmit();
    } else if (filter === "CreatedBy") {
      this.getSkillsByUserEmail();
    } else if (
      template === "In-App Walkthrough" ||
      template === "Blank Template" ||
      template === "UserDocumentation" ||
      template === "WebAutomation" ||
      template === "Import Data from Spreadsheet to Web App" ||
      template === "Desktop Walkthrough" ||
      template === "UserOnboarding" ||
      template === "UserOnboarding"
    ) {
      this.getSkillsByTemplate();
    } else {
      this.getPublishedSkill();
    }
  }

  getPublishedSkill = async () => {
    const queryParams = new URLSearchParams(window.location.search);
    let page = parseInt(queryParams.get("page")) || 1;
    let data = { page };
    const metaDataSkill = await this.props.getMetaDataSkills(data);
    metaDataSkill.data.data.results.map((item, i) => {
      item["kind"] = "onBoardedWalkThrough";
    });

    this.setState({
      metaSkillData: metaDataSkill.data.data.results,
    });

    if (metaDataSkill.data.data.results) {
      let allSkills = this.state.metaSkillData;

      allSkills.sort((a, b) => {
        return new Date(b.LAST_UPDATED_AT) - new Date(a.LAST_UPDATED_AT);
      });
      this.setState({
        isLoading: false,
        skills: allSkills,
        totalMetaSkills: metaDataSkill.data.data.totalCount,
        isScrolling: false,
        publishedPageInfo: [metaDataSkill.data.data.results],
      });
    } else {
      this.setState({
        isLoading: false,
        hasMore: false,
        isScrolling: false,
      });
    }
  };

  handleUserSubmit = async () => {
    if (this.state.createdBy === "CreatedBy Me") {
      this.setState({ checked: "CreatedBy Me", selectedTemplate: "" });
    }
    const queryParams = new URLSearchParams(window.location.search);
    let userPage = parseInt(queryParams.get("page")) || 1;
    const mainEmail = this.props?.userReducer?.user?.email;
    const filter = this.props?.skillReducer?.selectedFilter;
    const pageSize = 9;
    const data = { page: userPage, pageSize };
    const currentOrgId =
      this.props?.organizationReducer?.currentOrgUser?.organization_id;
    const metaDataSkill = await this.props.retrieveMyMetaSkill(
      mainEmail,
      data,
      currentOrgId
    );
    const content = `${filter ? filter : ""}`;
    metaDataSkill.results.map((item, i) => {
      item["kind"] = "onBoardedWalkThrough";
    });

    this.setState({
      checked: "byUser",
      metaSkillData: metaDataSkill.results,
      displayContent: content,
    });

    if (metaDataSkill.results) {
      let allSkills = this.state.metaSkillData;

      allSkills.sort((a, b) => {
        return new Date(b.LAST_UPDATED_AT) - new Date(a.LAST_UPDATED_AT);
      });
      this.setState({
        checked: "byUser",
        displayContent: content,
        isLoading: false,
        skills: allSkills,
        isScrolling: false,
      });
    } else {
      this.setState({
        isLoading: false,
        hasMore: false,
        isScrolling: false,
      });
    }
  };

  deleteMySkill = (e, id) => {
    let skillId = parseInt(
      this.props.skills.skillArea ? this.props.skills.skillArea.SKILL_ID : null
    );
    if (skillId !== null) {
      const deleteSkill = this.props.deleteMySkill(skillId);
      if (deleteSkill) {
        this.props.history.push(window.location.pathname);
      }
    }
  };

  deleteMyOnboardedSkill = async (e, id) => {
    let skillId = parseInt(this.props?.skills?.helper?.SKILL_ID);

    if (skillId !== "") {
      const deleteDraft = await this.props.deleteMySkill(skillId);
      if (deleteDraft) {
        if (
          this.props?.skills?.helper?.SKILL_METADATA?.Template ===
          "GenAi Automation"
        ) {
          let agentId =
            this.props.skillReducer?.helper?.SKILL_METADATA?.v2AgentId;
          await this.props.deleteV2Agent(agentId);
          this.props.history.push(window.location.pathname);
          this.props.clearDraft();
        } else {
          this.props.history.push(window.location.pathname);
          this.props.clearDraft();
        }
      }
    }
  };

  chatSkill = (skill) => {
    try {
      chrome.runtime.sendMessage(
        process.env.REACT_APP_CHROME_TAB_ID,
        { type: "ping" },
        (response) => {
          if (response) {
            this.props.chatSkill(skill);
          } else {
            this.notificationPopUp();
          }
        }
      );
    } catch (error) {
      this.notificationPopUp();
      console.log("error ", error);
    }
  };

  notificationPopUp() {
    Store.addNotification({
      title: "Note: ",
      message:
        "Ohh! Seems you don't have Super browser extension added to your browser. Please add it before creating/using skills.",
      type: "warning",
      insert: "top",
      container: "top-right",
      dismiss: {
        duration: 5000,
        onScreen: true,
      },
    });
    window.setTimeout(function () {
      window.open(
        `https://chrome.google.com/webstore/detail/techforce-ide-extension/${process.env.REACT_APP_CHROME_TAB_ID}`,
        "_blank"
      );
    }, 5000);
  }

  searchSkillStore = (e) => {
    this.setState({
      searchItem: e.target.value,
    });
    this.props.setSearchQuery(e.target.value);
  };

  onKeyPress = (e) => {
    if (e.key === "Enter") {
      this.setState({
        isSearching: true,
      });
      this.props.history.push({
        pathname: `/dashboard/skills/searchSkill/published?query=${this.state.searchItem}`,
      });
      this.props.setSearchQuery(this.state.searchItem);
    }
  };

  handlePageChange = (pageNumber) => {
    this.setState({ publishedPage: pageNumber, isLoading: true });
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set("page", pageNumber); //setting the page parameter to the URL
    this.props.history.push({ search: queryParams.toString() });
  };

  getSkillsByUserEmail = async () => {
    if (this.state.createdBy === "CreatedBy") {
      this.setState({ checked: "CreatedBy", selectedTemplate: "" });
    }
    const queryParams = new URLSearchParams(window.location.search);
    let otherUserPage = parseInt(queryParams.get("page")) || 1;
    const { createdBy } = this.state;
    const email = this.props?.skillReducer?.userEmail;
    const pageSize = 9;
    const data = { page: otherUserPage, pageSize };
    const currentOrgId =
      this.props?.organizationReducer?.currentOrgUser?.organization_id;
    const metaDataSkill = await this.props.retrieveMetaByEmail(
      data,
      currentOrgId,
      email
    );
    const content = email ? email : createdBy ? `${createdBy}:` : "";
    metaDataSkill.results.map((item, i) => {
      item["kind"] = "onBoardedWalkThrough";
    });

    this.setState({
      checked: "byUser",
      metaSkillData: metaDataSkill.results,
      displayContent: content,
    });

    if (metaDataSkill.results) {
      let allSkills = this.state.metaSkillData;

      allSkills.sort((a, b) => {
        return new Date(b.LAST_UPDATED_AT) - new Date(a.LAST_UPDATED_AT);
      });
      this.setState({
        displayContent: content,
        isLoading: false,
        skills: allSkills,
        isScrolling: false,
        checked: "byUser",
      });
    } else {
      this.setState({
        isLoading: false,
        hasMore: false,
        isScrolling: false,
      });
    }
  };

  getUniqueTemplates = async () => {
    this.setState({ isTemplateLodaing: true });
    const metaDataSkill = await this.props.retrieveAllMetaTemplates();
    metaDataSkill?.results?.map((item, i) => {
      item["kind"] = "onBoardedWalkThrough";
    });

    this.setState({
      metaSkillData: metaDataSkill?.results,
    });

    if (metaDataSkill?.results) {
      let allSkills = this.state.metaSkillData;

      allSkills.sort((a, b) => {
        return new Date(b.LAST_UPDATED_AT) - new Date(a.LAST_UPDATED_AT);
      });
      this.setState({
        isTemplateLodaing: false,
        isLoading: false,
        uniqueSkills: allSkills,
        isScrolling: false,
      });
    } else {
      this.setState({
        isTemplateLodaing: false,
        isLoading: false,
        hasMore: false,
        isScrolling: false,
      });
    }
  };

  handleCreatedByChange = (value) => {
    this.props.setSelectedFilter(value);
    this.setState({
      createdBy: value,
      userEmail: "",
    });
  };

  handleUserPageChange = (pageNumber) => {
    const filter = this.props?.skillReducer?.selectedFilter;
    this.props.setSelectedFilter(filter);
    this.setState({ userPage: pageNumber, isLoading: true });
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set("page", pageNumber);
    window.history.replaceState(
      {},
      "",
      `${window.location.pathname}?${queryParams.toString()}`
    );
    this.handleUserSubmit(pageNumber);
  };

  handleOtherUserPageChange = (pageNumber) => {
    this.setState({ otherUserPage: pageNumber, isLoading: true }, () => {});
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set("page", pageNumber);
    window.history.replaceState(
      {},
      "",
      `${window.location.pathname}?${queryParams.toString()}`
    );
    this.getSkillsByUserEmail(pageNumber);
  };

  handleInAppPageChange = (pageNumber) => {
    this.setState({ inAppPage: pageNumber, isLoading: true });
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set("page", pageNumber);
    window.history.replaceState(
      {},
      "",
      `${window.location.pathname}?${queryParams.toString()}`
    );
    this.getSkillsByTemplate(pageNumber);
  };

  handleBlankPageChange = (pageNumber) => {
    this.setState({ blankPage: pageNumber, isLoading: true });
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set("page", pageNumber);
    window.history.replaceState(
      {},
      "",
      `${window.location.pathname}?${queryParams.toString()}`
    );
    this.getSkillsByTemplate(pageNumber);
  };

  handleUserDocPageChange = (pageNumber) => {
    this.setState({ userDocPage: pageNumber, isLoading: true });
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set("page", pageNumber);
    window.history.replaceState(
      {},
      "",
      `${window.location.pathname}?${queryParams.toString()}`
    );
    this.getSkillsByTemplate(pageNumber);
  };

  handleUserOnPageChange = (pageNumber) => {
    this.setState({ userOnPage: pageNumber, isLoading: true });
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set("page", pageNumber);
    window.history.replaceState(
      {},
      "",
      `${window.location.pathname}?${queryParams.toString()}`
    );
    this.getSkillsByTemplate(pageNumber);
  };

  handleWebAutoPageChange = (pageNumber) => {
    this.setState({ webAutoPage: pageNumber, isLoading: true });
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set("page", pageNumber);
    window.history.replaceState(
      {},
      "",
      `${window.location.pathname}?${queryParams.toString()}`
    );
    this.getSkillsByTemplate(pageNumber);
  };

  handleImportPageChange = (pageNumber) => {
    this.setState({ importPage: pageNumber, isLoading: true });
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set("page", pageNumber);
    window.history.replaceState(
      {},
      "",
      `${window.location.pathname}?${queryParams.toString()}`
    );
    this.getSkillsByTemplate(pageNumber);
  };

  handleSkillSetPageChange = (pageNumber) => {
    this.setState({ skillSetPage: pageNumber, isLoading: true });
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set("page", pageNumber);
    window.history.replaceState(
      {},
      "",
      `${window.location.pathname}?${queryParams.toString()}`
    );
    this.getSkillsByTemplate(pageNumber);
  };

  handleDesktopPageChange = (pageNumber) => {
    this.setState({ desktopPage: pageNumber, isLoading: true });
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set("page", pageNumber);
    window.history.replaceState(
      {},
      "",
      `${window.location.pathname}?${queryParams.toString()}`
    );
    this.getSkillsByTemplate(pageNumber);
  };

  handleSelectChange = (value, pageNumber) => {
    this.props.setSelectedFilter(value);
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.delete("page");
    const queryString = queryParams.toString();
    const newUrl = queryString
      ? `${window.location.pathname}?${queryString}`
      : window.location.pathname;
    window.history.replaceState({}, "", newUrl);
    this.setState(
      {
        checked: value,
        selectedTemplate: "",
        createdBy: "",
        skills: [],
        isLoading: true,
      },
      () => {
        switch (value) {
          case "all":
            this.getPublishedSkill(pageNumber);
            break;
          case "byUser":
            this.setState({ isLoading: true });
            this.props.setSelectedFilter("all");
            this.getPublishedSkill(pageNumber);
            break;
          case "byTemplate":
            this.setState({ isLoading: true });
            this.props.setSelectedFilter("all");
            this.getPublishedSkill(pageNumber);
            break;
          default:
            // Handle default case if needed
            break;
        }
      }
    );
  };

  handleTemplateChange = (event) => {
    const value = event.target.value;
    this.setState({ selectedTemplate: value });
    this.props.setSelectedTemplate(value);
  };

  getSkillsByTemplate = async () => {
    this.setState({ createdBy: "" });
    const template = this.props?.skillReducer?.selectedTemplate;
    try {
      let filter = template;
      const queryParams = new URLSearchParams(window.location.search);
      let page = parseInt(queryParams.get("page")) || 1;
      let data = { page, filter };
      const metaDataSkill = await this.props.retrieveFilteredMetaSkill(data);
      const content = `${template ? template : ""}`;
      metaDataSkill.results.map((item, i) => {
        item["kind"] = "onBoardedWalkThrough";
      });

      this.setState({
        checked: "byTemplate",
        displayContent: content,
        metaSkillData: metaDataSkill.results,
      });

      if (metaDataSkill.results) {
        let allSkills = this.state.metaSkillData;

        allSkills.sort((a, b) => {
          return new Date(b.LAST_UPDATED_AT) - new Date(a.LAST_UPDATED_AT);
        });
        this.setState({
          checked: "byTemplate",
          displayContent: content,
          isLoading: false,
          skills: allSkills,
          isScrolling: false,
        });
      } else {
        this.setState({
          isLoading: false,
          hasMore: false,
          isScrolling: false,
        });
      }
    } catch (error) {
      console.error("Error fetching skills by template:", error);
      // Handle errors if needed
    }
  };

  render() {
    const { uniqueSkills, selectedTemplate, createdBy } = this.state;
    const uniqueTemplateNamesSet = new Set();
    if (uniqueSkills && uniqueSkills.length > 0) {
      uniqueSkills.forEach((skill) => {
        if (skill && skill.SKILL_METADATA && skill.SKILL_METADATA.Template) {
          uniqueTemplateNamesSet.add(skill.SKILL_METADATA.Template);
        }
      });
    }
    const uniqueTemplateNamesArray = Array.from(uniqueTemplateNamesSet);
    const queryParams = new URLSearchParams(window.location.search);
    const publishedPage = parseInt(queryParams.get("page")) || 1;
    const userPage = parseInt(queryParams.get("page")) || 1;
    const otherUserPage = parseInt(queryParams.get("page")) || 1;
    const inAppPage = parseInt(queryParams.get("page")) || 1;
    const blankPage = parseInt(queryParams.get("page")) || 1;
    const webAutoPage = parseInt(queryParams.get("page")) || 1;
    const importPage = parseInt(queryParams.get("page")) || 1;
    const userOnPage = parseInt(queryParams.get("page")) || 1;
    const userDocPage = parseInt(queryParams.get("page")) || 1;
    const desktopPage = parseInt(queryParams.get("page")) || 1;
    const skillSetPage = parseInt(queryParams.get("page")) || 1;
    const filter = this.props?.skillReducer?.selectedFilter;
    const template = this.props?.skillReducer?.selectedTemplate;
    return (
      <React.Fragment>
        {/* Published Skill */}
        <div className="task-col-search">
          <div className="row mx-0 setting-search bg-white py-3 border-left">
            <div className="col-md-8">
              <div className="position-relative search">
                <input
                  id="searchField"
                  type="search"
                  placeholder="Search"
                  className="form-control border-0"
                  value={this.state.searchItem ? this.state.searchItem : ""}
                  onChange={(e) => this.searchSkillStore(e)}
                  onKeyDown={(e) => this.onKeyPress(e)}
                />
                {/* <img src={SearchIcon} alt="Search" /> */}
              </div>
            </div>
          </div>

          <div className="task-col">
            <div className="title-btn tab-title-btn">
              {/* <h1 className="title">Published Skills</h1> */}
              {/* <h1 className="title">Added From Skill Hub</h1> */}

              <div className="title-tabs">
                <button
                  className="btn btn-default"
                  onClick={() => {
                    this.props.changeActiveTab("Created By Team");

                    this.props.history.push("/dashboard/skills/draft");
                    this.props.changeMode(false);
                  }}
                >
                  Created by Team
                </button>
                <button
                  className="btn btn-default active"
                  onClick={() => {
                    this.props.changeActiveTab("Added From Agent Hub");

                    this.props.history.push("/dashboard/skills/published");
                    this.props.changeMode(false);
                  }}
                >
                  Added From Agent Hub{" "}
                </button>
                {/* Process Discovery */}
                <button
                  className="btn btn-default"
                  onClick={() => {
                    this.props.changeActiveTab("Process Discovery");

                    this.props.history.push(
                      "/dashboard/skills/process-discovery"
                    );
                    this.props.changeMode(false);
                  }}
                >
                  Process Discovery
                </button>
              </div>

              <div className="radio-btns filter-row">
                <div className="filter-sort">
                  <Select
                    //defaultValue="Filter By"
                    value={this.props?.skillReducer?.selectedFilter}
                    style={{
                      width: 120,
                    }}
                    options={[
                      {
                        value: "all",
                        label: "Filters",
                      },
                      {
                        value: "byUser",
                        label: (
                          <span data-toggle="modal" data-target="#userModal1">
                            By User
                          </span>
                        ),
                      },
                      {
                        value: "byTemplate",
                        label: (
                          <span
                            data-toggle="modal"
                            data-target="#templateModal"
                            onClick={this.getUniqueTemplates}
                          >
                            By Template
                          </span>
                        ),
                      },
                    ]}
                    onChange={this.handleSelectChange}
                  />
                  {this.state.displayContent ? (
                    <div className="filter-badge">
                      <span>
                        {this.state.displayContent === "GenAi Automation"
                          ? "Workflow AI Agent"
                          : this.state.displayContent}
                      </span>
                      {/* <button className="close"
                        >
                        X
                      </button> */}
                      <Button
                        onClick={() => {
                          this.setState({
                            isLoading: true,
                            createdBy: "",
                            checked: "all",
                            displayContent: "",
                          });
                          this.props.setSelectedFilter("all");
                          this.props.setSelectedTemplate("all");
                          this.getPublishedSkill();
                        }}
                        shape="circle"
                        icon={<CloseOutlined />}
                      />
                    </div>
                  ) : null}
                </div>
              </div>
            </div>

            {filter === "CreatedBy Me" ? (
              <div id="scrollableDiv" className="scrollable tl-scroll">
                {this.state.isLoading ? (
                  <Loader
                    styles={{ width: "80px", margin: "auto" }}
                    root={{ display: "flex" }}
                  />
                ) : (
                  <div>
                    {this.state.isLoading === false &&
                    !this.state.skills.length ? (
                      <div>
                        <EmptyLoader
                          style={{ width: "30%" }}
                          message="No Agents found"
                        />
                      </div>
                    ) : (
                      <div>
                        {this.state.skills.map((item, key) => {
                          switch (item.kind) {
                            case "onBoardedWalkThrough":
                              return (
                                <MyHelperItem
                                  color={getColors(item.SKILL_NAME)}
                                  key={key}
                                  skill={item}
                                  {...this.props}
                                />
                              );
                          }
                        })}
                        <div className="template-flex">
                          <div className="template-box scrollable">
                            <Pagination
                              current={userPage}
                              pageSize={9}
                              total={this.props.myMetaCount}
                              onChange={this.handleUserPageChange}
                              hideOnSinglePage={false}
                              showSizeChanger={false}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            ) : filter === "CreatedBy" ? (
              <div id="scrollableDiv" className="scrollable tl-scroll">
                {this.state.isLoading ? (
                  <Loader
                    styles={{ width: "80px", margin: "auto" }}
                    root={{ display: "flex" }}
                  />
                ) : (
                  <div>
                    {this.state.isLoading === false &&
                    !this.state.skills.length ? (
                      <div>
                        <EmptyLoader
                          style={{ width: "30%" }}
                          message="No Agents found"
                        />
                      </div>
                    ) : (
                      <div>
                        {this.state.skills.map((item, key) => {
                          switch (item.kind) {
                            case "onBoardedWalkThrough":
                              return (
                                <MyHelperItem
                                  color={getColors(item.SKILL_NAME)}
                                  key={key}
                                  skill={item}
                                  {...this.props}
                                />
                              );
                          }
                        })}
                        <div className="template-flex">
                          <div className="template-box scrollable">
                            <Pagination
                              current={otherUserPage}
                              pageSize={9}
                              total={this.props.metaByEmailCount}
                              onChange={this.handleOtherUserPageChange}
                              hideOnSinglePage={false}
                              showSizeChanger={false}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            ) : template === "In-App Walkthrough" ? (
              <div id="scrollableDiv" className="scrollable tl-scroll">
                {this.state.isLoading ? (
                  <Loader
                    styles={{ width: "80px", margin: "auto" }}
                    root={{ display: "flex" }}
                  />
                ) : (
                  <div>
                    {this.state.isLoading === false &&
                    !this.state.skills.length ? (
                      <div>
                        <EmptyLoader
                          style={{ width: "30%" }}
                          message="No Agents found"
                        />
                      </div>
                    ) : (
                      <div>
                        {this.state.skills.map((item, key) => {
                          switch (item.kind) {
                            case "onBoardedWalkThrough":
                              return (
                                <MyHelperItem
                                  color={getColors(item.SKILL_NAME)}
                                  key={key}
                                  skill={item}
                                  {...this.props}
                                />
                              );
                          }
                        })}
                        <div className="template-flex">
                          <div className="template-box scrollable">
                            <Pagination
                              current={inAppPage}
                              pageSize={9}
                              total={this.props.filteredMetaCount}
                              onChange={this.handleInAppPageChange}
                              hideOnSinglePage={false}
                              showSizeChanger={false}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            ) : template === "Blank Template" ? (
              <div id="scrollableDiv" className="scrollable tl-scroll">
                {this.state.isLoading ? (
                  <Loader
                    styles={{ width: "80px", margin: "auto" }}
                    root={{ display: "flex" }}
                  />
                ) : (
                  <div>
                    {this.state.isLoading === false &&
                    !this.state.skills.length ? (
                      <div>
                        <EmptyLoader
                          style={{ width: "30%" }}
                          message="No Agents found"
                        />
                      </div>
                    ) : (
                      <div>
                        {this.state.skills.map((item, key) => {
                          switch (item.kind) {
                            case "onBoardedWalkThrough":
                              return (
                                <MyHelperItem
                                  color={getColors(item.SKILL_NAME)}
                                  key={key}
                                  skill={item}
                                  {...this.props}
                                />
                              );
                          }
                        })}
                        <div className="template-flex">
                          <div className="template-box scrollable">
                            <Pagination
                              current={blankPage}
                              pageSize={9}
                              total={this.props.filteredMetaCount}
                              onChange={this.handleBlankPageChange}
                              hideOnSinglePage={false}
                              showSizeChanger={false}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            ) : template === "UserDocumentation" ? (
              <div id="scrollableDiv" className="scrollable tl-scroll">
                {this.state.isLoading ? (
                  <Loader
                    styles={{ width: "80px", margin: "auto" }}
                    root={{ display: "flex" }}
                  />
                ) : (
                  <div>
                    {this.state.isLoading === false &&
                    !this.state.skills.length ? (
                      <div>
                        <EmptyLoader
                          style={{ width: "30%" }}
                          message="No Agents found"
                        />
                      </div>
                    ) : (
                      <div>
                        {this.state.skills.map((item, key) => {
                          switch (item.kind) {
                            case "onBoardedWalkThrough":
                              return (
                                <MyHelperItem
                                  color={getColors(item.SKILL_NAME)}
                                  key={key}
                                  skill={item}
                                  {...this.props}
                                />
                              );
                          }
                        })}
                        <div className="template-flex">
                          <div className="template-box scrollable">
                            <Pagination
                              current={userDocPage}
                              pageSize={9}
                              total={this.props.filteredMetaCount}
                              onChange={this.handleUserDocPageChange}
                              hideOnSinglePage={false}
                              showSizeChanger={false}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            ) : template === "UserOnboarding" ? (
              <div id="scrollableDiv" className="scrollable tl-scroll">
                {this.state.isLoading ? (
                  <Loader
                    styles={{ width: "80px", margin: "auto" }}
                    root={{ display: "flex" }}
                  />
                ) : (
                  <div>
                    {this.state.isLoading === false &&
                    !this.state.skills.length ? (
                      <div>
                        <EmptyLoader
                          style={{ width: "30%" }}
                          message="No Agents found"
                        />
                      </div>
                    ) : (
                      <div>
                        {this.state.skills.map((item, key) => {
                          switch (item.kind) {
                            case "onBoardedWalkThrough":
                              return (
                                <MyHelperItem
                                  color={getColors(item.SKILL_NAME)}
                                  key={key}
                                  skill={item}
                                  {...this.props}
                                />
                              );
                          }
                        })}
                        <div className="template-flex">
                          <div className="template-box scrollable">
                            <Pagination
                              current={userOnPage}
                              pageSize={9}
                              total={this.props.filteredMetaCount}
                              onChange={this.handleUserOnPageChange}
                              hideOnSinglePage={false}
                              showSizeChanger={false}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            ) : template === "WebAutomation" ? (
              <div id="scrollableDiv" className="scrollable tl-scroll">
                {this.state.isLoading ? (
                  <Loader
                    styles={{ width: "80px", margin: "auto" }}
                    root={{ display: "flex" }}
                  />
                ) : (
                  <div>
                    {this.state.isLoading === false &&
                    !this.state.skills.length ? (
                      <div>
                        <EmptyLoader
                          style={{ width: "30%" }}
                          message="No Agents found"
                        />
                      </div>
                    ) : (
                      <div>
                        {this.state.skills.map((item, key) => {
                          switch (item.kind) {
                            case "onBoardedWalkThrough":
                              return (
                                <MyHelperItem
                                  color={getColors(item.SKILL_NAME)}
                                  key={key}
                                  skill={item}
                                  {...this.props}
                                />
                              );
                          }
                        })}
                        <div className="template-flex">
                          <div className="template-box scrollable">
                            <Pagination
                              current={webAutoPage}
                              pageSize={9}
                              total={this.props.filteredMetaCount}
                              onChange={this.handleWebAutoPageChange}
                              hideOnSinglePage={false}
                              showSizeChanger={false}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            ) : template === "Import Data from Spreadsheet to Web App" ? (
              <div id="scrollableDiv" className="scrollable tl-scroll">
                {this.state.isLoading ? (
                  <Loader
                    styles={{ width: "80px", margin: "auto" }}
                    root={{ display: "flex" }}
                  />
                ) : (
                  <div>
                    {this.state.isLoading === false &&
                    !this.state.skills.length ? (
                      <div>
                        <EmptyLoader
                          style={{ width: "30%" }}
                          message="No Agents found"
                        />
                      </div>
                    ) : (
                      <div>
                        {this.state.skills.map((item, key) => {
                          switch (item.kind) {
                            case "onBoardedWalkThrough":
                              return (
                                <MyHelperItem
                                  color={getColors(item.SKILL_NAME)}
                                  key={key}
                                  skill={item}
                                  {...this.props}
                                />
                              );
                          }
                        })}
                        <div className="template-flex">
                          <div className="template-box scrollable">
                            <Pagination
                              current={importPage}
                              pageSize={9}
                              total={this.props.filteredMetaCount}
                              onChange={this.handleImportPageChange}
                              hideOnSinglePage={false}
                              showSizeChanger={false}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            ) : template === "Skill Set" ? (
              <div id="scrollableDiv" className="scrollable tl-scroll">
                {this.state.isLoading ? (
                  <Loader
                    styles={{ width: "80px", margin: "auto" }}
                    root={{ display: "flex" }}
                  />
                ) : (
                  <div>
                    {this.state.isLoading === false &&
                    !this.state.skills.length ? (
                      <div>
                        <EmptyLoader
                          style={{ width: "30%" }}
                          message="No Agents found"
                        />
                      </div>
                    ) : (
                      <div>
                        {this.state.skills.map((item, key) => {
                          switch (item.kind) {
                            case "onBoardedWalkThrough":
                              return (
                                <MyHelperItem
                                  color={getColors(item.SKILL_NAME)}
                                  key={key}
                                  skill={item}
                                  {...this.props}
                                />
                              );
                          }
                        })}
                        <div className="template-flex">
                          <div className="template-box scrollable">
                            <Pagination
                              current={skillSetPage}
                              pageSize={9}
                              total={this.props.filteredMetaCount}
                              onChange={this.handleSkillSetPageChange}
                              hideOnSinglePage={false}
                              showSizeChanger={false}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            ) : template === "Desktop Walkthrough" ? (
              <div id="scrollableDiv" className="scrollable tl-scroll">
                {this.state.isLoading ? (
                  <Loader
                    styles={{ width: "80px", margin: "auto" }}
                    root={{ display: "flex" }}
                  />
                ) : (
                  <div>
                    {this.state.isLoading === false &&
                    !this.state.skills.length ? (
                      <div>
                        <EmptyLoader
                          style={{ width: "30%" }}
                          message="No Agents found"
                        />
                      </div>
                    ) : (
                      <div>
                        {this.state.skills.map((item, key) => {
                          switch (item.kind) {
                            case "onBoardedWalkThrough":
                              return (
                                <MyHelperItem
                                  color={getColors(item.SKILL_NAME)}
                                  key={key}
                                  skill={item}
                                  {...this.props}
                                />
                              );
                          }
                        })}
                        <div className="template-flex">
                          <div className="template-box scrollable">
                            <Pagination
                              current={desktopPage}
                              pageSize={9}
                              total={this.props.filteredMetaCount}
                              onChange={this.handleDesktopPageChange}
                              hideOnSinglePage={false}
                              showSizeChanger={false}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            ) : (
              <div id="scrollableDiv" className="scrollable tl-scroll">
                {this.state.isLoading ? (
                  <Loader
                    styles={{ width: "80px", margin: "auto" }}
                    root={{ display: "flex" }}
                  />
                ) : (
                  <div>
                    {this.state.isLoading === false &&
                    !this.state.skills.length ? (
                      <div>
                        <EmptyLoader
                          style={{ width: "30%" }}
                          message="No Agents found"
                        />
                      </div>
                    ) : (
                      <div>
                        {this.state.skills.map((item, key) => {
                          switch (item.kind) {
                            case "onBoardedWalkThrough":
                              return (
                                <MyHelperItem
                                  color={getColors(item.SKILL_NAME)}
                                  key={key}
                                  skill={item}
                                  {...this.props}
                                />
                              );
                          }
                        })}
                        <div className="template-flex">
                          <div className="template-box scrollable">
                            <Pagination
                              current={publishedPage}
                              pageSize={9}
                              total={this.state.totalMetaSkills}
                              onChange={this.handlePageChange}
                              hideOnSinglePage={false}
                              showSizeChanger={false}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        <div
          id="userModal1"
          class="modal fade crt-skill"
          role="dialog"
          data-keyboard="false"
          data-backdrop="static"
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
            }
          }}
        >
          <div class="modal-dialog">
            <div class="modal-content crt-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">
                  &times;
                </button>
                <h4 class="modal-title">By User</h4>
              </div>
              <div class="modal-body">
                <form class="form-contain" action="javascript:void(0)">
                  <div className="frm-block">
                    <div className="frm-radio-box">
                      <div className="frm-radio-item">
                        <input
                          type="radio"
                          value="CreatedBy Me"
                          checked={createdBy === "CreatedBy Me"}
                          onChange={() =>
                            this.handleCreatedByChange("CreatedBy Me")
                          }
                          id="CreatedBy Me"
                        />
                        <label for="CreatedBy Me">Created by Me</label>
                      </div>
                      <div className="frm-radio-item">
                        <input
                          type="radio"
                          value="CreatedBy"
                          checked={createdBy === "CreatedBy"}
                          onChange={() =>
                            this.handleCreatedByChange("CreatedBy")
                          }
                          id="CreatedBy"
                        />
                        <label for="CreatedBy">Created by Other User</label>
                      </div>
                    </div>
                    <div className="frm-email-input">
                      {createdBy === "CreatedBy" && (
                        <input
                          type="text"
                          placeholder="Enter email"
                          ref={this.emailInputRef}
                          value={this.props.userEmail}
                          onChange={(e) =>
                            this.props.setUserEmail(e.target.value)
                          }
                        />
                      )}
                    </div>
                  </div>
                  <div class="frm-btns">
                    <button
                      class="btn btn-outline"
                      data-dismiss="modal"
                      onClick={() => this.props.setUserEmail("")}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-primary"
                      data-dismiss="modal"
                      onClick={() => {
                        this.setState({ isLoading: true }, () => {
                          if (this.state.createdBy === "CreatedBy Me") {
                            this.handleUserSubmit();
                          } else {
                            this.getSkillsByUserEmail(this.state.userEmail);
                          }
                        });
                      }}
                    >
                      {this.state.isLoading ? (
                        <div className="sp sp-circle text-light"></div>
                      ) : (
                        "Submit"
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <div
          id="templateModal"
          className="modal fade crt-skill"
          role="dialog"
          data-keyboard="false"
          data-backdrop="static"
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
            }
          }}
        >
          <div class="modal-dialog">
            <div class="modal-content crt-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">
                  &times;
                </button>
                <h4 class="modal-title"> By Template</h4>
              </div>
              <div class="modal-body">
                <form class="form-contain" action="javascript:void(0)">
                  <div class="frm-block">
                    <select
                      value={this.props.selectedTemplate}
                      onChange={this.handleTemplateChange}
                    >
                      <option value="" disabled={this.state.isLoading}>
                        {this.state.isTemplateLodaing &&
                        uniqueTemplateNamesArray.length === 0
                          ? "Loading..."
                          : "Select Template"}
                      </option>
                      {uniqueTemplateNamesArray
                        .filter(
                          (templateName) =>
                            templateName === "In-App Walkthrough" ||
                            templateName === "Skill Set" ||
                            templateName === "Blank Template" ||
                            templateName === "WebAutomation" ||
                            templateName === "UserOnboarding" ||
                            templateName === "UserDocumentation"||
                            templateName === "GenAi Automation"
                        )
                        .map((templateName) => (
                          <option key={templateName} value={templateName}>
                            {templateName === "GenAi Automation"
                              ? "Workflow AI Agent"
                              : templateName}
                          </option>
                        ))}
                    </select>
                  </div>
                  <div class="frm-btns">
                    <button
                      class="btn btn-outline"
                      data-dismiss="modal"
                      onClick={() => {
                        this.props.setSelectedTemplate("");
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      class="btn btn-primary"
                      data-dismiss="modal"
                      onClick={() => {
                        this.setState({ isLoading: true }, () => {
                          this.getSkillsByTemplate();
                        });
                      }}
                    >
                      {this.state.isLoading ? (
                        <div class="sp sp-circle text-light"></div>
                      ) : (
                        "Submit"
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* My Published Skill Delete Modal */}
        <div
          className="modal fade qa-modal1"
          id="mySkillDeleteModal"
          role="dialog"
        >
          <div className="modal-dialog modal-sm">
            <div className="modal-content share-modal">
              <button type="button" className="close" data-dismiss="modal">
                &times;
              </button>
              <div className="modal-body">
                <h3 className="qa-modal-title">Delete</h3>
                <div>
                  <h5>Please confirm delete action.</h5>
                </div>

                <div className="frm-btns fb-right">
                  <button className="btn-outline" data-dismiss="modal">
                    Cancel
                  </button>
                  <button
                    className="btn-primary"
                    data-dismiss="modal"
                    onClick={() => {
                      this.deleteMySkill();
                    }}
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Delete modal */}
        <div className="modal fade qa-modal1" id="myDeleteModal" role="dialog">
          <div className="modal-dialog modal-sm">
            <div className="modal-content share-modal">
              <button type="button" className="close" data-dismiss="modal">
                &times;
              </button>
              <div className="modal-body">
                <h3 className="qa-modal-title">Delete</h3>
                <div>
                  <h5>Please confirm delete action.</h5>
                </div>

                <div className="frm-btns fb-right">
                  <button className="btn-outline" data-dismiss="modal">
                    Cancel
                  </button>
                  <button
                    className="btn-primary"
                    data-dismiss="modal"
                    onClick={() => {
                      this.deleteMyOnboardedSkill();
                    }}
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
const mapStateToProps = (state) => ({
  skills: state.skillReducer,
  userReducer: state.userReducer,
  searchTerm: state.searchTerm,
  appReducer: state.appReducer,
  snackReducer: state.snackReducer,
  skillReducer: state.skillReducer,
  organizationReducer: state.organizationReducer,
  metaByEmailCount: state.skillReducer.metaByEmailCount,
  myMetaCount: state.skillReducer.myMetaCount,
  filteredMetaCount: state.skillReducer.filteredMetaCount,
  userEmail: state.skillReducer.userEmail,
  selectedTemplate: state.skillReducer.selectedTemplate,
});

export default compose(
  withRouter,
  connect(mapStateToProps, {
    getSkillsFromStore,
    addSkillToUser,
    filterSearchItem,
    notify,
    getUserSkills,
    deleteMySkill,
    changeSkillAreaView,
    getUserHelperSkills,
    getDraftSkills,
    getMetaDataSkills,
    clearDraft,
    retrieveMyMetaSkill,
    retrieveMetaByEmail,
    retrieveFilteredMetaSkill,
    retrieveAllTemplates,
    retrieveAllMetaTemplates,
    changeActiveTab,
    changeMode,
    setUserEmail,
    setSelectedFilter,
    setSelectedTemplate,
    setSearchQuery,
    deleteV2Agent,
  })
)(MyPublishedSkills);
